import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';
import LoaderComponent from '@components/LoaderComponent';

import { useFetchMaterialRequisitionInventoryQuery } from '@features/material-requisition/api/materialRequisitionApi';

import { changeDateFormat } from '@utils/Util';

const ViewInventory = ({ onCloseModal, selectedRequisition }) => {
	const { data: materials, isLoading } = useFetchMaterialRequisitionInventoryQuery(
		{ materialRequisitionId: selectedRequisition.id },
		{ skip: !selectedRequisition.id }
	);

	return (
		<LoaderComponent loading={isLoading}>
			<ModalContainer className="inventory-list-mdoal">
				<div className="popup-wrapper">
					<div className="common-popup">
						<ModalHeader title="Inventory List" onClose={onCloseModal} />
						<div className="common-popup-body scroll-y-label">
							<div className="material-requirement-table">
								<table className="table height-sm hover with-border">
									<thead>
										<tr>
											<th>Reference Number</th>
											<th>Received Date</th>
											<th>Quantity</th>
											<th>Unit Price (BDT)</th>
										</tr>
									</thead>
									<tbody>
										{materials?.map((item) => (
											<tr>
												<td>{item.materialReferenceNumber}</td>
												<td>
													{changeDateFormat(
														item.receivedDate,
														'YYYY-MM-DD',
														'DD MMM, YYYY'
													)}
												</td>
												<td>{item.quantity}</td>
												<td>{item.unitPrice}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</ModalContainer>
		</LoaderComponent>
	);
};

export default ViewInventory;
